import { Col, Form, Input, Row, theme, Select, Divider, Typography, message, notification, Popover, Checkbox } from "antd";
import EditQty from "./EditQty";
import { useEffect, useState, useMemo } from "react";
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router";
import EOLService from "../../services/EOLService";
import LoadingSpin from "../loadingSpin/LoadingSpin";
import ManageBinService from "../../services/ManageBinService";
import ResponseMessage from "../Comman/Notification/ResponseMessge";

const ViewKanban = ({
    userData
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [dispatchArea, setDispatchArea] = useState();
    const { Title, Text } = Typography;
    const [kbNumber, setKbNumber] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [getKanbanData, setKanbanData] = useState();
    const [api, contextHolder] = notification.useNotification();
    const [BinOptions, setBinOptions] = useState();
    const [selectedBin, setSelectedBin] = useState(null);
    const [binFull, setBinFull] = useState('no');

    const [bin, setBin] = useState(null);
    const [isPopoverVisible, setIsPopoverVisible] = useState(false);

    console.log(binFull);
    

    useEffect(() => {
        const fetchKanbanData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const kbNumValue = queryParams.get('kb_num');
            setKbNumber(kbNumValue);

            if (!kbNumValue) {
                // message.error("No Kanban number provided.");
                ResponseMessage.error({ message:"No Kanban number provided."});
                return;
            }

            setIsLoading(true);
            try {
                const response = await EOLService.getKanbanDataById({ kb_number: kbNumValue });
                const garmentResponse = await ManageBinService.getBinData();

                const BinOptions = garmentResponse.data
                    .filter(item => item.bin_location === "dispatch_center")
                    .map(item => ({
                        value: item.bin_id,
                        label: item.bin_id
                    }));
                setBinOptions(BinOptions);
                console.log(garmentResponse.data);

                if (Array.isArray(response.data) && response.data.length > 0) {
                    setKanbanData(response.data);
                } else {
                    openNotificationWithIcon('warning', 'No Data Found', response.message || 'No Kanban data available.');
                    navigate('/eol-dashboard');
                }
            } catch (error) {
                console.error("Error fetching Kanban data:", error);
                openNotificationWithIcon('error', 'Error', 'An error occurred while fetching data.');
                navigate('/eol-dashboard');
            } finally {
                setIsLoading(false);
            }
        };

        fetchKanbanData();
    }, [location]);

    console.log("kbNumber", kbNumber);
    const openNotificationWithIcon = (type, title, description) => {
        api[type]({
            message: title,
            description,
        });
    };

    const kanbanData1 = useMemo(() => {
        return Array.isArray(getKanbanData) && getKanbanData.length > 0
            ? getKanbanData.map(item => ({
                kanbanNo: item.kb_number,
                poNo: item.po_no,
                quantity: item.quantity,
                color: item.color,
                itemNo: item.item_no,
                country: item.country,
                totalQty: item.tot_qty,
            }))
            : [];
    }, [getKanbanData]);

    const handleArrowClick = () => {
        navigate('/eol-dashboard');
    };

    useEffect(() => {
        if (kanbanData1.length > 0) {
            form.setFieldsValue(kanbanData1[0]);
        }
    }, [kanbanData1, form]);
    const sizeCollection = useMemo(() => {

        return Array.isArray(getKanbanData)
            ? getKanbanData.map(item => {
                const sizes = JSON.parse(item.size_name || '{}');
                const totals = JSON.parse(item.tot_qty || '{}');
                console.log("totals", totals);
                console.log("sizes", sizes);
                // API problem: here totals and size is not matching  ??                

                return Object.keys(sizes).map((size, idx) => {
                    const availableQty = sizes[size] || "0";
                    const totalQty = totals[size] || "0";

                    if (availableQty === "0" && totalQty === "0") {
                        return null;
                    }
                    console.log(availableQty);
                    
                    return {
                        key: `${idx + 1}`,
                        size,
                        availableQty,
                        totalQty,
                        kanban_no: item.kb_number,
                    };
                }).filter(Boolean); // Filter out null entries
            }).flat()
            : [];
    }, [getKanbanData]);
    console.log(sizeCollection);


    const formStyle = {
        marginTop: '-15px',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };

    const onFinish = (values) => {
        console.log("Form Submitted:", values);
    };

    const DispatchAreaOptions = [
        { id: 1, name: 'Washing', label: 'Washing', value: 'Washing' },
        { id: 2, name: 'Hold Area', label: 'Hold Area', value: 'Hold Area' },
        { id: 3, name: 'Finishing', label: 'Finishing', value: 'Finishing' },
    ];

    const handleBinChange = (value) => {
        setBin(value);
        console.log('Selected bin:', value);
        message.success(`Bin ${value} Selected`);
        setIsPopoverVisible(false);
    };


    const onChangeCheckBox = (e) => {
        console.log(`checked = ${e.target.checked ? "yes" : "no"}`);
        setBinFull(e.target.checked ? "yes" : "no");
    };    

    return (
        <div>
            <Title level={5} style={{ marginTop: -15, margin: 0 }}>
                <div>
                    <>
                        <ArrowLeftOutlined onClick={handleArrowClick} style={{ paddingRight: '10px' }} />
                        END of Line Dispatch
                    </>
                </div>
            </Title>

            <Divider style={{ marginTop: 8 }} />
            {contextHolder}
            {isLoading && <LoadingSpin />}
            {!isLoading && (

                <Form
                    form={form}
                    name="simple_search"
                    style={formStyle}
                    onFinish={onFinish}
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 18,
                    }}
                >
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name="kanbanNo" label="Kanban NO">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="itemNo" label="Item No">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name="poNo" label="PO NO">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="color" label="Color">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name="country" label="Country">
                                <Input
                                    style={{
                                        backgroundColor: '#9F5375',
                                        color: 'white',
                                        borderRadius: '0px',
                                    }}
                                    readOnly
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="dispatchTo" label="Dispatch To">
                                <Select
                                    required
                                    style={{
                                        color: '#9F5375',
                                        width: '100%',
                                    }}
                                    options={DispatchAreaOptions}
                                    value={dispatchArea}
                                    onChange={(value) => {
                                        console.log('Selected value:', value);
                                        setDispatchArea(value);
                                        setSelectedBin(null);
                                    }}
                                    placeholder="Select dispatch area"
                                />

                                {dispatchArea === 'Washing' && (
                                    <>
                                        <Select
                                            required
                                            style={{
                                                color: '#9F5375',
                                                width: '100%',
                                                marginTop: '10px',
                                            }}
                                            value={selectedBin}
                                            onChange={(value) => {
                                                setSelectedBin(value);
                                            }}
                                            placeholder="Select Bin"
                                            options={BinOptions}
                                        />
                                        <Checkbox
                                            onChange={onChangeCheckBox}
                                            style={{ paddingTop: '15px' }}
                                        >
                                            Bin Full
                                        </Checkbox>
                                    </>

                                )}
                            </Form.Item>
                        </Col>
                    </Row>

                    <div
                        style={{
                            marginTop: '20px',
                            marginLeft: '10%',
                        }}
                    >
                        <EditQty
                            binFull={binFull}
                            selectedBin={selectedBin}
                            dispatchArea={dispatchArea}
                            userData={userData}
                            handleArrowClick={handleArrowClick}
                            editValue={sizeCollection} />
                    </div>
                </Form>
            )};
        </div>
    );
};

export default ViewKanban;